<script setup>
import { onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import opmStore from '@/lib/storeOwnerProjectManager';

const router = useRouter();

onBeforeMount(async() => {
    router.push(opmStore.state.chrome.home.replace(/^\/#/, ''));
})
</script>

<template>
    <div></div>
</template>